import {toast} from 'react-toastify';
import { api } from '@/api';
import { certificateApiReq } from '@/api/interfaces/requests';
import {NAME_STATUS_API_ORDER} from '../../../consts';

export const activateCertificate = (data: certificateApiReq.IActivateCertificateReq) => {
    const response = api.certificate.activateCertificate(data);
    toast.promise(
        response,
        {
            pending: 'Идет процесс ',
            // success: 'Сертификат успешно активирован!',
            error: {
                render(res: Record<string, any>) {
                    const {data, status} = res.data.response;
                    if (status === 500) {
                        toast.error(NAME_STATUS_API_ORDER.ACTIVATE_CERTIFICATE.ERROR_500);
                    }
                    if (Array.isArray(data)) {
                        data.forEach((item: string) => {
                            toast.error(item);
                        });
                    } else {
                        Object.keys(data).forEach((key) => {
                            toast.error(data[key][0]);
                        });
                    }

                    return NAME_STATUS_API_ORDER.ACTIVATE_CERTIFICATE.ERROR
                }
            }
        });
    return response;
};